module.exports = __webpack_public_path__ + "img/close.946725ad.svg";